module.exports = __webpack_public_path__ + "img/svip_extract_bg.99e6cdaa.png";